import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import chartData from '../../data/profitChart.json';
import useIsMobile from '../../hooks/useIsMobile';

const ProfitChart = () => {
  const isMobile = useIsMobile();
  const chartHeight = isMobile ? 250 : 300;

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
        <XAxis
          dataKey="date"
          stroke="#9CA3AF"
          tick={{ fontSize: isMobile ? 10 : 12 }}
          interval={isMobile ? 2 : 'preserveStartEnd'}
        />
        <YAxis
          stroke="#9CA3AF"
          tick={{ fontSize: isMobile ? 10 : 12 }}
        />
        <Tooltip
          contentStyle={{ backgroundColor: '#1F2937', border: '1px solid #374151', borderRadius: '8px' }}
          labelStyle={{ color: '#9CA3AF', fontSize: isMobile ? '12px' : '14px' }}
        />
        <Line
          type="monotone"
          dataKey="cumulativeReturn"
          stroke="url(#colorGradient)"
          strokeWidth={2}
          dot={false}
        />
        <defs>
          <linearGradient id="colorGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
        </defs>
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ProfitChart;
